import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

const DiscoverSection = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      },
      {
        threshold: 0.2
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className="discover-section" ref={sectionRef}>
      <div className="discover-overlay"></div>
      <div className="discover-content">
        <h2>{t('vacationSpot.title')}</h2>
        <p>{t('vacationSpot.subtitle')}</p>
        <button className="discover-button" onClick={() => navigate('/search-results')}>{t('vacationSpot.button')}</button>
      </div>
    </section>
  );
};

export default DiscoverSection; 